module.exports = __webpack_public_path__ + "img/chocoli.15047fa1.jpeg";